// JS Base
import '../js/index';

// Base SCSS
import '../scss/base.scss';
import '../scss/components/card.scss';
import '../scss/components/carousel.scss';

import '../scss/home.scss';

import Carousel from '../js/components/carousel';
import CarouselNav from '../js/components/carouselnav';

$(() => {
	const testimonials = new Carousel('.testimonials-carousel', null, {
    768: 'unslick',
  });
	testimonials.init();

  const stepByStep = new Carousel(
    '.step-by-step .card-reveal-slider',
    {
        infinite: false,
        centerMode: true,
        slidesToShow: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        dots: false,
        autoplay: false
    },
    {
      768: {
        slidesToShow: 1
      }
    }
  );
  const modaalStepByStep = () => $('.step-by-step .modaal-image').modaal({ type: 'image' });
	stepByStep.init(modaalStepByStep);

  const stepByStepNav = new CarouselNav('.step-by-step .slider-nav', stepByStep);
  stepByStepNav.init();
});
